export default __webpack_public_path__ + "static/media/Q10_4_resized.9f7f80a0.jpg";